import React,{useState,useEffect} from "react";
import Customercharts from "./Customercharts";
import { getAuthorization } from "../../../../axios/AxiosAut";

export default function Customerdata() {

  const [OnGoingorders, setOnGoingorders] = useState([]);
  const getData = () => {
    getAuthorization()
      .get(`dashboard/customers/get_ongoing_orders/`)
      .then((res) => {
        console.log(" data", res.data.ongoing_orders
        );
        setOnGoingorders(res.data.ongoing_orders
          );
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    getData();
    console.log("OnGoingorders.....", OnGoingorders);
  }, [OnGoingorders]);
  return (
    <div>
      <div class="flex flex-wrap justify-center mt-8">
        <div className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 ">
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1 left-1.5"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.5 9.5H7.69294C7.25267 9.5 7.03254 9.5 6.82538 9.54973C6.64172 9.59383 6.46614 9.66656 6.30509 9.76525C6.12344 9.87656 5.96778 10.0322 5.65647 10.3435L4.34353 11.6565C4.03222 11.9678 3.87656 12.1234 3.76525 12.3051C3.66656 12.4661 3.59383 12.6417 3.54973 12.8254C3.5 13.0325 3.5 13.2527 3.5 13.6929V17.62C3.5 18.6281 3.5 19.1321 3.69619 19.5172C3.86876 19.8559 4.14413 20.1312 4.48282 20.3038C4.86786 20.5 5.37191 20.5 6.38 20.5H17.62C18.6281 20.5 19.1321 20.5 19.5172 20.3038C19.8559 20.1312 20.1312 19.8559 20.3038 19.5172C20.5 19.1321 20.5 18.6281 20.5 17.62V13.6929C20.5 13.2527 20.5 13.0325 20.4503 12.8254C20.4062 12.6417 20.3334 12.4661 20.2348 12.3051C20.1234 12.1234 19.9678 11.9678 19.6565 11.6565L18.3435 10.3435C18.0322 10.0322 17.8766 9.87656 17.6949 9.76525C17.5339 9.66656 17.3583 9.59383 17.1746 9.54973C16.9675 9.5 16.7473 9.5 16.3071 9.5H15.5"
                    stroke="#1F78B4"
                  />
                  <path
                    d="M20.5 14.5H17.9415C17.2458 14.5 16.8979 14.5 16.636 14.6888C16.3742 14.8775 16.2642 15.2075 16.0442 15.8675L15.9558 16.1325C15.7358 16.7925 15.6258 17.1225 15.364 17.3112C15.1021 17.5 14.7542 17.5 14.0585 17.5H9.94152C9.2458 17.5 8.89794 17.5 8.63605 17.3112C8.37416 17.1225 8.26416 16.7925 8.04415 16.1325L7.95585 15.8675C7.73584 15.2075 7.62584 14.8775 7.36395 14.6888C7.10206 14.5 6.7542 14.5 6.05848 14.5H3.5"
                    stroke="#1F78B4"
                  />
                  <circle cx="12" cy="8" r="3.5" stroke="#1F78B4" />
                  <path d="M12 6V10" stroke="#1F78B4" />
                  <path d="M14 8H10" stroke="#1F78B4" />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">58</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            New Orders
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">45.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6">
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative  top-1 left-1"
                  width="44"
                  height="44"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    rx="6.04167"
                    ry="6.04167"
                    transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 14.5 18.125)"
                    fill="white"
                    fill-opacity="0.29"
                  />
                  <path
                    d="M8.15833 18.125C8.15833 14.6226 10.9976 11.7833 14.5 11.7833C18.0024 11.7833 20.8417 14.6226 20.8417 18.125C20.8417 21.6274 18.0024 24.4666 14.5 24.4666C10.9976 24.4666 8.15833 21.6274 8.15833 18.125Z"
                    stroke="white"
                    stroke-opacity="0.29"
                    stroke-width="0.6"
                  />
                  <path
                    d="M6.32988 17.8975C6.81179 19.696 7.87369 21.2852 9.35089 22.4187C10.8281 23.5522 12.638 24.1666 14.5 24.1666C16.362 24.1666 18.1719 23.5522 19.6491 22.4187C21.1263 21.2852 22.1882 19.696 22.6701 17.8975"
                    stroke="#1F78B4"
                    stroke-width="1.2"
                  />
                  <path
                    d="M14.5 15.7084L14.1252 16.1769L14.5 16.4767L14.8748 16.1769L14.5 15.7084ZM15.1 4.83338C15.1 4.502 14.8314 4.23337 14.5 4.23337C14.1686 4.23337 13.9 4.502 13.9 4.83338L15.1 4.83338ZM8.08352 11.3436L14.1252 16.1769L14.8748 15.2399L8.83315 10.4065L8.08352 11.3436ZM14.8748 16.1769L20.9165 11.3436L20.1669 10.4065L14.1252 15.2399L14.8748 16.1769ZM15.1 15.7084L15.1 4.83338L13.9 4.83338L13.9 15.7084L15.1 15.7084Z"
                    fill="#1F78B4"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">75</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Outstanding Orders
          </h1>
          <p className="text-red-600 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">03.88%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 ">
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1 left-2"
                  width="44"
                  height="44"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.5 11C3.5 9.10025 3.50106 7.72573 3.64199 6.67754C3.78098 5.64373 4.04772 5.00253 4.52513 4.52513C5.00253 4.04772 5.64373 3.78098 6.67754 3.64199C7.72573 3.50106 9.10025 3.5 11 3.5H13C14.8998 3.5 16.2743 3.50106 17.3225 3.64199C18.3563 3.78098 18.9975 4.04772 19.4749 4.52513C19.9523 5.00253 20.219 5.64373 20.358 6.67754C20.4989 7.72573 20.5 9.10025 20.5 11V13C20.5 14.8998 20.4989 16.2743 20.358 17.3225C20.219 18.3563 19.9523 18.9975 19.4749 19.4749C18.9975 19.9523 18.3563 20.219 17.3225 20.358C16.2743 20.4989 14.8998 20.5 13 20.5H11C9.10025 20.5 7.72573 20.4989 6.67754 20.358C5.64373 20.219 5.00253 19.9523 4.52513 19.4749C4.04772 18.9975 3.78098 18.3563 3.64199 17.3225C3.50106 16.2743 3.5 14.8998 3.5 13V11Z"
                    stroke="#1F78B4"
                  />
                  <path
                    d="M12 8L12 16"
                    stroke="#1F78B4"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 12L8 12"
                    stroke="#1F78B4"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">{OnGoingorders}</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Ongoing Orders
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">45.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl ">
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-0 left-1"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.1422 20.2176C24.5591 18.6619 24.6125 17.0312 24.2982 15.4516C23.984 13.8719 23.3107 12.3858 22.3302 11.108C21.3498 9.83025 20.0885 8.79517 18.644 8.08284C17.1996 7.3705 15.6106 7 14 7C12.3894 7 10.8004 7.3705 9.35597 8.08284C7.91149 8.79517 6.65024 9.83025 5.66979 11.108C4.68934 12.3858 4.01596 13.8719 3.70175 15.4516C3.38755 17.0312 3.44093 18.6619 3.85778 20.2176"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M14.8933 18.1793C15.462 19.0068 15.0621 20.2694 14 20.9992C12.938 21.7291 11.616 21.6498 11.0473 20.8223C10.4174 19.9057 8.18269 14.5862 6.93297 11.5619C6.72827 11.0665 7.33424 10.6501 7.72332 11.0187C10.0987 13.2696 14.2635 17.2627 14.8933 18.1793Z"
                    stroke="#1F78B4"
                  />
                  <path
                    d="M14 7V9.33333"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M6.57532 10.075L8.22523 11.7249"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M21.4247 10.075L19.7748 11.7249"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M24.1423 20.2173L21.8884 19.6134"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M3.85773 20.2173L6.11155 19.6134"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">86</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Repair Scheduled
          </h1>
          <p className="text-red-600 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">03.88%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
      </div>
      <Customercharts/>
    </div>
  );
}
